<template>
  <NInviteAsyncContainer :loading="verifyLoading" :blank="true">
  <div class="invite-reg-download-con">
    <div style="display: flex; flex-direction: row; align-items: center; margin-top: 30px">
      <span
          style="
          font-size: 16px;
          color: #9d9d9d;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
        "
      >{{ $tl('inviteDownloadsTitle1') }}</span
      >
    </div>
    <img
        src="/images/invite_reg/icon_upload_bg.png"
        style="width: 215px; height: 431px; align-self: center; margin-top: 28px"
    />
    <img
        src="/images/invite_reg/icon_upload.png"
        style="width: 47px; height: 47px; align-self: center; margin-top: 31px"
    />
    <p style="margin-top: 12px; text-align: center; font-size: 16px; color: #b2b2b2">
      {{ $tl('inviteDownloadsTitle2') }}
    </p>
    <p style="margin-top: 7px; text-align: center; font-size: 12px; color: #9d9d9d">
     {{ $tl('inviteDownloadsTitle3') }}
    </p>

    <div v-if="resultNg.errorCode" style="margin-top: 5px; text-align: center; color: var(--ant-error-color);">
      <span>{{ t(resultNg.errorCode, PREFIX.ERROR_CODE) }}</span>
    </div>
    
    <div
        style="
        display: flex;
        justify-content: space-between;
        margin-left: 16px;
        margin-right: 16px;
        margin-top: 30px;
      "
    >
      <div class="invite-reg-download-upload_box">
        <img src="/images/invite_reg/icon_apple.png" style="width: 16px; height: 18px; left: 0px; top: 5px" />
        <span class="invite-reg-download-upload-spn">{{ $tl('inviteDownloadsAppleLabel') }}</span>
        <button
            @click="openIosAppLink"
            class="invite-reg-download-upload-btn">
          {{ $tl('inviteDownloadsBtnLabel') }}
        </button>
      </div>
      <div class="invite-reg-download-upload_box">
        <img src="/images/invite_reg/icon_google.png" style="width: 14px; height: 14px; left: 0px; top: 5px; right: 1px;" />
        <span class="invite-reg-download-upload-spn-g">{{ $tl('inviteDownloadsGooglePlayLabel') }}</span>
        <button
            @click="openMacArmDesktopAppLink"
            class="invite-reg-download-upload-btn">
          {{ $tl('inviteDownloadsBtnLabel') }}
        </button>
      </div>
      <div class="invite-reg-download-upload_box">
        <img src="/images/invite_reg/icon_android.png" style="width: 16px; height: 18px; left: 0px; top: 5px" />
        <span class="invite-reg-download-upload-spn-a">{{ $tl('inviteDownloadsAndroidLabel') }}</span>
        <button
            @click="openAndroidAppLink"
            class="invite-reg-download-upload-btn">
          {{ $tl('inviteDownloadsBtnLabel') }}
        </button>
      </div>
    </div>
  </div>
  </NInviteAsyncContainer>
</template>

<script setup>
import {computed, onMounted, reactive, ref} from "vue";
import { useLanguage, useRouter} from "@/hooks";
import { getAppDownloadUrl} from "@front/api/utility";

const { router, routerTo } = useRouter();
const { tl, t, PREFIX } = useLanguage();
const username = computed(() => decodeURIComponent(router.currentRoute.value.params.username));
const resultOk = reactive({
  success: false,
  agent: null,
});
const resultNg = reactive({
  success: false,
  errorCode: null,
  message: null,
});
const downloadLinks = reactive({});
const verifyLoading = ref(true);

onMounted( async ()=>{
  
  try {
    verifyLoading.value = true;
    const r = await getAppDownloadUrl({ username: username.value});
    resultOk.success = r.success;
    // 老黄说怕影响其他调用，目前只能这么改
    // resultOk.agent = r.data.message;
    downloadLinks.iosAppLink = r.data.iosAppLink;
    downloadLinks.androidAppLink = r.data.androidAppLink;
    downloadLinks.windowsDesktopAppLink = r.data.windowsDesktopAppLink;
    downloadLinks.macX86DesktopAppLink = r.data.macX86DesktopAppLink;
    downloadLinks.macArmDesktopAppLink = r.data.macArmDesktopAppLink;
    downloadLinks.webLink = r.data.webLink;

    // resultNg.errorCode = 'INVALID_ARGUMENT_INVALID_ISSUER_FORMAT';
    
  } catch (err) {
    resultNg.success = err.extra?.success;
    resultNg.errorCode = err.extra?.errorCode;
    resultNg.message = err.extra?.message;
  } finally {
    verifyLoading.value = false;
  }
  
})



const openIosAppLink = () => window.open(downloadLinks.iosAppLink, '_blank');
const openAndroidAppLink = () => window.open(downloadLinks.androidAppLink, '_blank');
const openWindowsDesktopAppLink = () => window.open(downloadLinks.windowsDesktopAppLink, '_blank');
const openMacX86DesktopAppLink = () => window.open(downloadLinks.macX86DesktopAppLink, '_blank');
const openMacArmDesktopAppLink = () => window.open(downloadLinks.macArmDesktopAppLink, '_blank');
const openWebLink = () => window.open(downloadLinks.webLink, '_blank');


</script>

<style>
.invite-reg-download-con {
  width: 100vw;
  height: 100vh;
  overflow-y: auto;
  background: #242424;
  display: flex;
  flex-direction: column;
}
.invite-reg-download-upload_box {
  width: 100px;
  height: 80px;
  position: relative;
}
.invite-reg-download-upload_box img {
    position: absolute;
}
.invite-reg-download-upload_box span {
    position: absolute;
}
.invite-reg-download-upload_box button {
    position: absolute;
}
.invite-reg-download-upload-btn {
  width: 96px;
  height: 41px;
  font-size: 10px;
  bottom: 5px;
  background-color: #4285f4;
  color: white;
  border-radius: 3px;
}

.invite-reg-download-upload-spn {
  font-size: 14px; color: #e6e6e6; left: 20px; top:2px;
}
.invite-reg-download-upload-spn-g {
  font-size: 13px; color: #e6e6e6; left: 20px; top:2px;
}
.invite-reg-download-upload-spn-a {
  font-size: 13px; color: #e6e6e6; left: 24px; top:4px;
}
</style>
